export const environment = {
  production: true,
  buildId: '2879431667019631',
  configFile: 'config.json',
};
